import React, { createContext, useContext, useState } from 'react';

const UserDetailContext = createContext();

export const useUserDetails = () => {
    return useContext(UserDetailContext);
}

export const UserDetailProvider = ({ children }) => {
    const [userDetails, setUserDetails] = useState(null);

    const value = {
        userDetails,
        setUserDetails
    };

    return (
        <UserDetailContext.Provider value={value}>
            {children}
        </UserDetailContext.Provider>
    );
}
